import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetIptvDataQuery } from '../redux/apis/linkManagement/iptv/index/lmIptvApiSlice'

const IptvAppDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
  mode='',
  disabled
}) => {
  const { data, isLoading, error } = useGetIptvDataQuery({
    page: '*',
    fields: ['id','app_name'].join(','),
  })

useEffect(()=>{
        if ( !error && !isLoading) {
            return
        }
        toast.error(error)
    },[error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">IPTV App Name</label>
      <br />
      <Select
        name='app_name'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.app_name, value: x.id }
        })}
        mode={mode}
        disabled={disabled}
      />
    </div>
  )
}

export default IptvAppDropdown
